var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import MSALAuthService from "@ane/core/lib/services/MSALAuthService/MSALAuthService";
import { ErrorCodes } from "@ane/core/lib/services/MSALAuthService/interface";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { AuthContextProvider } from "./AuthContextProvider.js";
import { withAuthContext } from "./withAuthContext.js";
import { TreatmentAssigmentProvider } from "./TreatmentAssigmentProvider.js";
import { SessionExpired } from "./SessionExpired.js";
class AppShell extends React.Component {
  render() {
    var _a, _b;
    return (_b = (_a = this.props) == null ? void 0 : _a.children) != null ? _b : null;
  }
}
const AppWithAuthContext = withAuthContext(AppShell);
const SessionExpiredWithAuthContext = withAuthContext(SessionExpired);
const AuthShell = ({ history, children }) => {
  const authContext = React.useMemo(() => {
    return MSALAuthService;
  }, [history]);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  React.useEffect(() => {
    if (authContext) {
      const checkLogin = () => __async(void 0, null, function* () {
        var _a;
        const _isLoggedIn = yield authContext.isUserLoggedIn();
        if (_isLoggedIn) {
          const msalUser = authContext.getUser();
          if (!!msalUser) {
            const user = {
              alias: (_a = msalUser == null ? void 0 : msalUser.email) == null ? void 0 : _a.replace(/@.*$/, ""),
              displayName: msalUser == null ? void 0 : msalUser.name,
              email: msalUser == null ? void 0 : msalUser.email,
              name: msalUser == null ? void 0 : msalUser.email,
              oid: msalUser == null ? void 0 : msalUser.oid,
              tid: msalUser == null ? void 0 : msalUser.tid
            };
            EnvironmentService.setUser(user);
          }
        }
        setIsLoggedIn(_isLoggedIn);
      });
      checkLogin();
    }
  }, [authContext]);
  const [showSessionExpired, setShowSessionExpired] = React.useState(false);
  React.useEffect(() => {
    const handleTokenTimeout = () => {
      setShowSessionExpired(true);
    };
    window.addEventListener(ErrorCodes.refreshAccessTokenTimeout, handleTokenTimeout);
    return () => {
      window.removeEventListener(ErrorCodes.refreshAccessTokenTimeout, handleTokenTimeout);
    };
  }, []);
  return showSessionExpired ? authContext ? /* @__PURE__ */ jsx(SessionExpired, { authContext }) : /* @__PURE__ */ jsx(AuthContextProvider, { history, children: /* @__PURE__ */ jsx(SessionExpiredWithAuthContext, {}) }) : authContext ? isLoggedIn ? /* @__PURE__ */ jsx(TreatmentAssigmentProvider, { children: /* @__PURE__ */ jsx(AppShell, { authContext, children }) }) : null : /* @__PURE__ */ jsx(TreatmentAssigmentProvider, { children: /* @__PURE__ */ jsx(AuthContextProvider, { history, children: /* @__PURE__ */ jsx(AppWithAuthContext, { children }) }) });
};
export {
  AppShell,
  AuthShell as default
};
//# sourceMappingURL=AuthShell.js.map
